'use client';

import { useBreakpoint } from '@repo/react-hooks';
import QuickDepositDrawer from '@/components/common/quick-deposit/quick-deposit-drawer';
import QuickDepositModal from '@/components/common/quick-deposit/quick-deposit-modal';
import { useAppStore } from '@/providers/AppStoreProvider';

export type QuickDepositProps = {
  open: boolean;
  handleOpen: (state: boolean) => void;
};

const QuickDeposit = () => {
  const { matches: isDesktop } = useBreakpoint('sm');

  const { isQuickDepositOpen, setIsQuickDepositOpen } = useAppStore((state) => ({
    isQuickDepositOpen: state.isQuickDepositOpen,
    setIsQuickDepositOpen: state.setIsQuickDepositOpen,
  }));

  if (isDesktop) {
    return (
      <QuickDepositModal
        open={isQuickDepositOpen}
        handleOpen={setIsQuickDepositOpen}
      />
    );
  }
  return (
    <QuickDepositDrawer
      open={isQuickDepositOpen}
      handleOpen={setIsQuickDepositOpen}
    />
  );
};

export default QuickDeposit;
